/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "antd-mobile";
import Theme from "../../utils/Theme";

const StyledContainer = styled.div`
  max-width: ${Theme.MaxWidth};
  background: white;
  width: 100%;
  overflow-x: hidden;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`;

const StyledContentContainter = styled.div`
  width: 80%;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

const StyledTopContainer = styled.div`
  margin-top: 40%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTitle = styled.span`
  margin-left: 10px;
  font-weight: 900;
  font-size: 1.5em;
  color: black;
  line-height: 1.6em;
`;

const StyledDescription = styled.span`
  font-size: 0.9em;
  color: gray;
  margin-top: 3%;
`;

const StyledButton = styled(Button)`
  margin-top: 20%;
  width: 100%;
  box-shadow: 0 4px 6px -5px grey;
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${props =>
      props.disabled ? "grey" : Theme.PrimaryColor};
  }
`;

class ResetPasswordSuccessPage extends Component {
  render() {
    const { history } = this.props;

    return (
      <StyledContainer>
        <StyledContentContainter>
          <StyledTopContainer>
            <img
              src={require("../../assets/icons/complete_green.png")}
              style={{ width: "2em" }}
            />
            <StyledTitle>
              <FormattedMessage
                id="reset.password.successful.title"
                defaultMessage="Reset Successful"
                description="Reset Successful Title"
              />
            </StyledTitle>
          </StyledTopContainer>
          <StyledDescription>
            <FormattedMessage
              id="reset.password.successful.description"
              defaultMessage="You will need to log in with your new password."
              description="Reset Successful Description"
            />
          </StyledDescription>
          <StyledButton
            activeStyle={{ backgroundColor: Theme.ActivePrimary }}
            onClick={() => history.push("/auth/login")}
          >
            <FormattedMessage
              id="auth.login.title"
              defaultMessage="Login"
              description="Login Title"
            />
          </StyledButton>
        </StyledContentContainter>
      </StyledContainer>
    );
  }
}

ResetPasswordSuccessPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default ResetPasswordSuccessPage;



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordSuccessPage/index.js